import type { AddToCartData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class AddToCartTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data?: AddToCartData): void {
    if (!this.factory.isManualEnabled('addToCart')) return;
    this.factory.dispatchManual('ADD_TO_CART', data);
  }
}
